import { render, staticRenderFns } from "./epro-details.vue?vue&type=template&id=1b427ed1&scoped=true&"
import script from "./epro-details.vue?vue&type=script&lang=js&"
export * from "./epro-details.vue?vue&type=script&lang=js&"
import style0 from "./epro-details.vue?vue&type=style&index=0&id=1b427ed1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b427ed1",
  null
  
)

component.options.__file = "epro-details.vue"
export default component.exports